import axiosInstance from '../configs/axios/interceptors';

const SuppliersServices = {

    getSuppliers: async (appliedFilters) => { 
        const response = await axiosInstance.get('Supplier/GetSupplierList', {params: appliedFilters});
        return response.data;
    },


    createSupplier: async (payload) => {   
        const response = await axiosInstance.post('Supplier/AddSupplier', payload);
        return response.data;
    },

    updateSupplier: async (payload) => {   
        const response = await axiosInstance.put('Supplier/UpdateSupplier', payload);
        return response.data;
    },

    getSupplier: async (supplierId) => {      
        const params = { supplierId };

        const response = await axiosInstance.get('Supplier/GetSupplier', {params: params});
        return response.data;
    },

    deleteSupplier: async (supplierId) => {      
        const params = { supplierId };

        const response = await axiosInstance.delete('Supplier/DeleteSupplier', {params: params});
        return response.data;
    },

};

export default SuppliersServices;